<app-dashboard-card
	title="Mentions"
	icon="pi pi-at"
>
	<div
		*ngIf="latestMentions.length === 0"
		class="dashboard-empty-state"
	>
		<i class="pi pi-check-circle"></i>
		<span>No mentions</span>
	</div>

	<div
		*ngIf="latestMentions.length > 0"
		class="mentions-summary-table-wrapper"
	>
		<table class="mentions-summary-table">
			<thead>
			<tr>
				<th>Date</th>
				<th>Comment</th>
				<th>Action</th>
			</tr>
			</thead>

			<tbody>
			<tr *ngFor="let mention of latestMentions">
				<td class="mention-date">
					{{
						mention.createdDate
							| DatePropertyTimezone: false : true
					}}
				</td>

				<td class="mention-comment">
					<ng-container *ngIf="!isCommentExpanded(mention); else expandedComment">
						{{ getCommentPreview(mention) }}

						<button
							*ngIf="isCommentLong(mention)"
							type="button"
							class="mention-comment-toggle"
							title="View full comment"
							(click)="toggleComment(mention)"
						>
							...
						</button>
					</ng-container>

					<ng-template #expandedComment>
						{{ mention.commentText }}

						<button
							type="button"
							class="mention-comment-toggle mention-comment-collapse"
							title="Collapse comment"
							(click)="toggleComment(mention)"
						>
							Show less
						</button>
					</ng-template>
				</td>

				<td class="mention-action">
					<button
						type="button"
						class="mention-view-link"
						(click)="onViewMention(mention)"
					>
						View
					</button>
				</td>
			</tr>
			</tbody>
		</table>
	</div>

	<div
		*ngIf="mentions.length > 0"
		class="mentions-summary-footer"
	>
		<button
			type="button"
			class="view-all-mentions-button"
			(click)="onViewAll()"
			title="Click to view all mentions"
		>
			<span>View all Mentions</span>

			<span class="mentions-count">
				{{ mentions.length }}
			</span>
		</button>
	</div>
</app-dashboard-card>
